import React from 'react'
import { makeStyles, Typography } from '@material-ui/core'
import GlueButton from '../glueos-components/glue-button'
import InputField from './input-field'
import LoadingIndicator from '../glueos-components/loading-indicator'
import { loginWithGoogle } from '../../services/login'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex'
  },

  logo: {
    width: '168px',
    height: '64px',
    margin: 'auto',
    marginBottom: theme.spacing('l')
  },

  main: {
    '@media (max-width:1024px)': {
      width: '100% !important'
    },
    width: '50%',
    minWidth: 'fit-content',
    display: 'flex',
    padding: '100px'
  },

  actionArea: {
    minWidth: '232px',
    display: 'flex',
    flexFlow: 'column',
    textAlign: 'center',
    gap: '50px',
    margin: 'auto',
    marginTop: 0
  },

  actionBlock: {
    display: 'flex',
    flexFlow: 'column',
    gap: theme.spacing('s')
  },

  googleBtnContent: {
    position: 'relative',
    height: '100%',
    display: 'flex',
    alignItems: 'center'
  },

  googleIcon: {
    width: '36px',
    position: 'absolute',
    left: '-42px'
  },

  getStarted: {
    display: 'flex',
    flexFlow: 'column',
    gap: theme.spacing('l')
  },

  promo: {
    '@media (max-width:1024px)': {
      display: 'none'
    },
    height: '100%',
    width: '800px',
    backgroundImage: 'url("https://glue-public-static-resources.s3-eu-west-1.amazonaws.com/web-images/GlueWeb_Promo_01_blank.png")',
    backgroundRepeat: 'no-repeat',
    paddingLeft: '88px',
    paddingTop: '136px',
    display: 'flex',
    flexFlow: 'column',
    gap: theme.spacing('m')
  },

  promoTitle: {
    width: '424px'
  },

  promoSubtitle: {
    '@media (min-width:1280px)': {
      width: '512px'
    },

    '@media (max-width:1280px)': {
      width: '256px'
    }
  }
}), { name: 'MuiGlueLoginPageWeb' })

const LoginPageWeb = (props) => {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      <div className={classes.main}>
        <div className={classes.actionArea}>
          <img className={classes.logo} src='https://glue-public-static-resources.s3-eu-west-1.amazonaws.com/web-images/GlueLogo_64.png' alt='' />
          <h1>Log in to Glue Web</h1>
          <div className={classes.actionBlock}>
            <InputField width='100%' label='Email' type='email' value={props.email} onChange={(value) => { props.setEmail(value); props.setInputError(null) }} error={props.inputError} onSubmitKey={!props.usePasswordLogin ? props.onPressNextButton : null} />
            {props.usePasswordLogin && (
              <InputField width='100%' label='Password' type='password' value={props.password} onChange={(value) => { props.setPassword(value); props.setInputError(null) }} error={!!props.inputError && ' '} onSubmitKey={props.onPressLoginButton} />
            )}
          </div>
          <div className={classes.actionBlock}>
            {props.usePasswordLogin ? (
              <GlueButton color='primary' onPointerDown={props.onPressLoginButton}>
                { props.loading ? (
                  <LoadingIndicator variant='button' />
                ) : (
                  <p>Log in</p>
                )}
              </GlueButton>
            ) : (
              <GlueButton disabled={!props.email} color='primary' onPointerDown={props.onPressNextButton}>
                { props.loading ? (
                  <LoadingIndicator variant='button' />
                ) : (
                  <p>Next</p>
                )}
              </GlueButton>
            )}
            <GlueButton color='google' onPointerDown={loginWithGoogle}>
              <div className={classes.googleBtnContent}>
                <img className={classes.googleIcon} src='https://glue-public-static-resources.s3-eu-west-1.amazonaws.com/web-images/LoginIcon_Google.png' alt='' />
                Continue with Google
              </div>
            </GlueButton>
            <GlueButton color='link' onPointerDown={props.openPasswordDialog}>Forgot password</GlueButton>
          </div>
          <div className={classes.getStarted}>
            <h2>Don&apos;t have an organization yet?</h2>
            <GlueButton color='orange' onPointerDown={() => {
              window.location.href = 'https://glue.work/get-started-create-a-team/'
            }}>Get started here</GlueButton>
          </div>
        </div>
      </div>
      <div className={classes.promo}>
        <div className={classes.promoTitle}>
          <h1>Manage your organization with Glue Web</h1>
        </div>
        <div className={classes.promoSubtitle}>
          <Typography variant='body2'>
            All your teams, users, spaces and files are found here.
          </Typography>
        </div>
      </div>
    </div>
  )
}

export default LoginPageWeb
